module.exports = __webpack_public_path__ + "img/control_de_calidad_9-16_540.f138133a.webp";